

















































import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { Action } from "vuex-class";
import { AppConstants as _app } from "@/shared/app.constants";
import { forEach } from "lodash";

@Component
export default class GenericNotificationComponent extends Vue {
  declarationContent: string = null;
  notificationId;
  buttonText: string = "";

  mounted() {}

  back() {
    const url =
      _app.generalNotifications[this.notificationId].url || "dashboard";
    this.$router.push({
      name: url,
      //query: { id: data }
    });
  }

  @Watch("$route.query.msgId", { immediate: true, deep: true })
  onUrlChange(newVal: any) {
    if (newVal) {
      this.notificationId = newVal;
      this.declarationContent =
        this.$t(
          _app.generalNotifications[this.notificationId].text
        ).toString() || "";
      this.buttonText =
        this.$t(
          _app.generalNotifications[this.notificationId].buttonText
        ).toString() || "Back";

      let params = this.$route.params;
      let self = this;
      if (params) {
        let keys = Object.keys(params);

        keys.forEach(function (key) {
          let placeholder = "{" + key + "}";
          self.declarationContent = self.declarationContent.replace(
            placeholder,
            params[key]
          );
        });
      }
    }
  }
}
